import { render, staticRenderFns } from "./ScanReportGroupsPage.vue?vue&type=template&id=44bf15ec"
import script from "./ScanReportGroupsPage.vue?vue&type=script&lang=js"
export * from "./ScanReportGroupsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports